import type { HeatmapClickPoint } from '../../submitSurvey/types';
import type { HeatmapRegion } from '../../fetchSurvey/types/heatmap';

export function isValidHeatmapClickPoint(value: unknown): value is HeatmapClickPoint {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as HeatmapClickPoint).id === 'string' &&
    typeof (value as HeatmapClickPoint).x === 'number' &&
    typeof (value as HeatmapClickPoint).y === 'number'
  );
}

export function normalizeHeatmapClicks(answer: unknown): HeatmapClickPoint[] {
  if (typeof answer === 'string') {
    try {
      return normalizeHeatmapClicks(JSON.parse(answer));
    } catch {
      return [];
    }
  }

  if (!Array.isArray(answer)) {
    return [];
  }

  const clicks: HeatmapClickPoint[] = [];

  for (const item of answer) {
    if (isValidHeatmapClickPoint(item)) {
      clicks.push({
        id: item.id,
        x: Math.min(1, Math.max(0, item.x)),
        y: Math.min(1, Math.max(0, item.y)),
      });
    }
  }

  return clicks;
}

export function isClickInsideRegion(click: HeatmapClickPoint, region: HeatmapRegion): boolean {
  const right = region.x + region.width;
  const bottom = region.y + region.height;

  return (
    click.x >= region.x &&
    click.x <= right &&
    click.y >= region.y &&
    click.y <= bottom
  );
}

export function getMatchedRegionLabels(
  clicks: HeatmapClickPoint[],
  regions: HeatmapRegion[]
): string[] {
  const matchedLabels: string[] = [];

  for (const region of regions) {
    for (const click of clicks) {
      if (isClickInsideRegion(click, region)) {
        if (!matchedLabels.includes(region.label)) {
          matchedLabels.push(region.label);
        }
        break;
      }
    }
  }

  return matchedLabels;
}
